(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product-recommendations"]) return;
  try {
    
function glAlignRecommendations(root) {
  root.querySelectorAll('[data-product-recommendations]').forEach(container => {
    if (container.dataset.glRowAlignment) return;
    container.dataset.glRowAlignment = 'true';
    let frame;
    let width = container.clientWidth;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!container.isConnected) return;
        const row = container.querySelector('[data-product-row]');
        if (!row) return;
        const cards = [...row.querySelectorAll('.productgrid--item')];
        const slider = row.querySelector('.flickity-slider');
        const viewport = row.querySelector('.flickity-viewport');
        cards.forEach(card => card.style.height = 'auto');
        row.style.height = '';
        if (slider) slider.style.height = 'auto';
        if (viewport) viewport.style.height = 'auto';
        const visible = cards.filter(card => getComputedStyle(card).display !== 'none');
        const height = Math.ceil(Math.max(0, ...visible.map(card => card.getBoundingClientRect().height)));
        if (!height) return;
        visible.forEach(card => card.style.height = height + 'px');
        if (slider && viewport) {
          slider.style.height = height + 'px';
          viewport.style.height = height + 'px';
          row.style.height = height + 'px';
        }
      });
    };
    const observer = new MutationObserver(align);
    observer.observe(container, {childList:true,subtree:true,characterData:true});
    const resize = new ResizeObserver(() => {
      if (container.clientWidth !== width) { width = container.clientWidth; align(); }
    });
    resize.observe(container);
    container.addEventListener('load', align, true);
    container.addEventListener('rimg:load', align);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      container.removeEventListener('load', align, true);
      container.removeEventListener('rimg:load', align);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    align();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => glAlignRecommendations(document), {once:true});
} else {
  glAlignRecommendations(document);
}
document.addEventListener('shopify:section:load', event => glAlignRecommendations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-recently-viewed"]) return;
  try {
    
function glAlignRecentCards(root) {
  root.querySelectorAll('[data-recently-viewed-container]').forEach(container => {
    if (container.dataset.glCardAlignment) return;
    container.dataset.glCardAlignment = 'true';
    let frame;
    let width = container.clientWidth;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!container.isConnected) return;
        const cards = [...container.querySelectorAll('.product-recently-viewed-card')];
        cards.forEach(card => card.style.height = 'auto');
        const height = Math.ceil(Math.max(0, ...cards.map(card => card.getBoundingClientRect().height)));
        cards.forEach(card => card.style.height = height + 'px');
        container.dispatchEvent(new CustomEvent('rimg:load'));
      });
    };
    const observer = new MutationObserver(align);
    observer.observe(container, {childList:true, subtree:true, characterData:true});
    const resize = new ResizeObserver(() => {
      if (container.clientWidth !== width) {
        width = container.clientWidth;
        align();
      }
    });
    resize.observe(container);
    container.addEventListener('load', align, true);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      container.removeEventListener('load', align, true);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    align();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => glAlignRecentCards(document), {once:true});
} else {
  glAlignRecentCards(document);
}
document.addEventListener('shopify:section:load', event => glAlignRecentCards(event.target));

  } catch(e) { console.error(e); }
})();
})();
